<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" @click="handleAdd">添加公告</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="公告ID" min-width="80" align="center" prop="noticeId" />
      <el-table-column label="公告标题" min-width="150" align="center" prop="noticeTitle" />
      <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
      <el-table-column label="状态" min-width="100" align="center" prop="statusDesc">
        <template slot-scope="scope">
          {{scope.row.status == '0' ? '已上线' : '已下线'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <el-button type="text" @click="editNotice(scope.row, '1')" v-if="scope.row.status == '0'">下线</el-button>
          <el-button type="text" @click="editNotice(scope.row, '0')" v-else>上线</el-button>
          <el-button type="text" @click="handleDelete(scope.row)" v-if="scope.row.status == '1'">删除</el-button>
          <el-button type="text" @click="handleEdit(scope.row)" v-if="scope.row.status == '1'">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="noticeList"
    />
    <AddNotice ref="addNoticeDialog" @success="getList"></AddNotice>
  </div>
</template>

<script>
import { noticeList, editNotice, deleteNotice } from "@/api/saas/package";
import AddNotice from "./components/addNoticeDialog";

export default {
  name: "NoticeList",
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
    };
  },
  created() {
    this.noticeList();
  },
  components: {
    AddNotice
  },
  methods: {
    handleAdd() {
      this.$refs.addNoticeDialog.open();
    },
    handleSee(row) {
      this.$refs.addNoticeDialog.open(JSON.parse(JSON.stringify(row)), 'see');
    },
    handleEdit(row) {
      this.$refs.addNoticeDialog.open(JSON.parse(JSON.stringify(row)), 'edit');
    },
    getList() {
      this.queryParams.pageNum = 1
      this.noticeList()
    },
    noticeList() {
      this.loading = true;
      noticeList(this.queryParams)
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total
        })
        .catch(error => {
          this.loading = false;
        });
    },
    editNotice(row, status) {
      this.$confirm(`确认${status === '0' ? '上线': '下线'}该公告吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.edit(row, status)
      })
    },
    edit(row, status) {
      editNotice({
        noticeId: row.noticeId,
        status: status
      })
        .then(response => {
          this.msgSuccess('更改成功！')
          this.noticeList()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    handleDelete(row){
      this.$confirm('确认删除该公告吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete(row)
      })
    },
    delete(row){
      deleteNotice({
        noticeId: row.noticeId,
      })
        .then(response => {
          this.msgSuccess('删除成功！')
          this.noticeList()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    }
  }
};
</script>
